import { render, staticRenderFns } from "./MalBody.vue?vue&type=template&id=0b1e6486&scoped=true&"
import script from "./MalBody.vue?vue&type=script&lang=js&"
export * from "./MalBody.vue?vue&type=script&lang=js&"
import style0 from "./MalBody.vue?vue&type=style&index=0&id=0b1e6486&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1e6486",
  null
  
)

export default component.exports